var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crop-and-upload"},[(_vm.uploading)?_c('drop-file',{key:"upload-image",staticClass:"dialog-drop-file",style:({backgroundColor: 'white'}),attrs:{"multiple":false,"maxFileSize":4,"accept":"image/*"},on:{"filesChanged":function (data) {
      _vm.formData = data
      _vm.uploading = false
      _vm.$store.dispatch('dialog/setTitle', 'Crop the image')
    }}}):_c('cropper',{key:"crop-image",attrs:{"file":_vm.file},on:{"cropperLoaded":_vm.cropperLoadedHandler}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-362a3086","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dialog/types/DialogCropAndUploadAvatar.vue
// module id = 1339
// module chunks = 22